







































import SMenu from '../menu';
import { message } from 'ant-design-vue';
import UserMenu from 'src/components/common/userMenu';
import Breadcrumb from 'src/components/common/Breadcrumb';
import { Component, Prop, Watch, Mixins, Vue } from "vue-property-decorator";
import { IAppModel, IUserLoginInfoModel } from '@/model';
import router from '../../../router'

@Component({
    components:
    {
        SMenu,
        UserMenu,
        Breadcrumb
    }
})
export default class GlobalHeader extends Vue
{

    /**
     * 菜单
     * @protected
     * @type {string}
    */
    @Prop({type: Array, required: true})
    protected menus: Array<any>;

    /**
     * 主题
     * @protected
     * @type {string}
    */
    @Prop({type: String, default: "dark"})
    protected theme: string;

    /**
     * 是否折叠
     * @protected
     * @type {string}
    */
    @Prop({type: Boolean, default: false})
    protected collapsed: boolean;

    /**
     * ticking
     * @protected
     * @type {boolean}
    */
    protected ticking: boolean = false;
    
    /**
     * 是否可见
     * @protected
     * @type {number}
    */
    protected oldScrollTop: number = 0;

    /**
     * 默认app集合
     * @protected
     * @type {array}
    */
    protected defApp: Array<IAppModel> = [];

    /**
     * 用户信息
     * @protected
     * @type {IUserLoginInfoModel}
    */
    protected get userInfo(): IUserLoginInfoModel
    {
        return JSON.parse(localStorage.getItem("profile"))
        // return this.$store.getters["user/profile"]
    }

    /**
     * 切换应用
     * @protected
     * @return void
     */
    protected switchApp(appId: number): void
    {
        this.defApp = [];
        const applicationData = this.userInfo.apps.filter(item => item.id === appId);
        if(!applicationData || applicationData.length === 0) {
            message.error('应用切换异常');
        }

        const hideMessage = message.loading('正在切换应用！', 0);
        let defaultApp = applicationData[0];

        // 调用菜单切换接口
        this.$store.dispatch("global/menuChange", defaultApp).then(() => {
            hideMessage();
        }).catch((err: any) => {
            message.error('应用切换异常');
        });
    }

    /**
     * 处理滚动
     * @protected
     * @return void
     */
    protected handleScroll(): void
    {
        const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
        if (!this.ticking) {
            this.ticking = true;
            requestAnimationFrame(() => {
                
                this.oldScrollTop = scrollTop;
                this.ticking = false;
            })
        }
    }

    /**
     * 滑动
     * @protected
     * @return void
     */
    protected toggle(): void
    {
        this.$emit("toggle");
    }

    /**
     * 钩子
     * @protected
     * @type {void}
    */
    protected created(): void
    {
        let appMenuStorage = localStorage.getItem("app_menu") || "[]";
        let appMenu = JSON.parse(appMenuStorage);
        let defautMenu = appMenu.length > 0 && appMenu[0];
        if (defautMenu) {
            this.defApp.push(defautMenu.code)
        }
    }

    /**
     * 钩子
     * @protected
     * @type {void}
    */
    protected mounted(): void
    {
        document.addEventListener("scroll", this.handleScroll, {
            passive: true
        })
    }

    /**
     * 钩子
     * @protected
     * @return void
     */
    protected beforeDestroy()
    {
        document.body.removeEventListener("scroll", this.handleScroll, true)
    }
}
